import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const AddRequisition = lazy(() => import("../pages/add-requisition"));
const AllRequisitions = lazy(() => import("../pages/listing"));
const RequisitionDetails = lazy(() => import("../pages/details"));
const RequisitionDashboard = lazy(() =>
  import("../pages/requisition-dashboard")
);

export const RequisitionRouter = [
  {
    path: "/requisition",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "my-requisitions",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllRequisitions />
          </Suspense>
        ),
      },
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <RequisitionDashboard />
          </Suspense>
        ),
      },
      {
        path: "create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AddRequisition />
          </Suspense>
        ),
      },
      {
        path: "edit/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AddRequisition />
          </Suspense>
        ),
      },
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllRequisitions />
          </Suspense>
        ),
      },
      {
        path: "details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <RequisitionDetails />
          </Suspense>
        ),
      },
      {
        path: "in-progress",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllRequisitions />
          </Suspense>
        ),
      },
      {
        path: "completed",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllRequisitions />
          </Suspense>
        ),
      },
      {
        path: "draft",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllRequisitions />
          </Suspense>
        ),
      },
      {
        path: "pending",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllRequisitions />
          </Suspense>
        ),
      },
    ],
  },
];
